import { defineStore } from 'pinia';
import userNews from '@/services/newsService';
import { News } from '@/types/news';

// Create a new store instance
export const UseStoreNews = defineStore('newsStore', {
  state: () => ({
    news: [] as News[],
  }),
  actions: {
    async loadNews(categorie: number) {
      await userNews.loadNews(categorie);
    },
    async setNews(news: News) {
      await this.news.push(news);
    },
    async setAllNews(news: News[]) {
      this.news = news;
    },
    async clearNews() {
      this.news.splice(0, this.news.length);
    },
  },
  getters: {
    getId: state => ({
      id: state.news[0].ID,
    }),
  },
});
